import { styled } from "@mui/material";
import * as MUI from "@mui/material";
import { customColors } from "models/customColors";

export const Container = styled(MUI.Stack)`
  flex: 1 1 auto;
  flex-direction: column;
  overflow-y: auto;
  gap: 1rem;
  padding: 1rem 2rem 0 2rem;

  @media (max-width: 768px) {
    padding: 0.5rem 1rem 0 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.5rem 0 0.5rem;
  }
`;

export const Properties = MUI.styled(MUI.Stack)`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 1em;
  width: 100%;
`;

export const Property = styled(MUI.Stack)`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.5em;
`;

export const ListHolder = styled(MUI.Grid)`
  padding: 1em;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

export const Title = styled(MUI.Box)`
  color: ${customColors.text};
  font-family: "Inter Bold";
  font-size: 20px;
  line-height: normal;

  @media (max-width: 640px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const SubTitle = styled(MUI.Box)`
  color: ${customColors.text};

  font-family: "Inter Medium";
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Paper = styled(MUI.Stack)`
  flex-direction: row;
  gap: 23px;
  
  padding: 23px 39px;
  width: 100%;

  border-radius: 13px;
  border: 1px solid #dfdfdf;
  background-color: ${customColors.white};

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
    flex-direction: column;
  }
`;

export const InfoSection = styled(MUI.Stack)`
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  column-gap: 2rem;
  row-gap: 0.5rem;
  
  padding: 14px 20px;
  
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 112.5% */
  border-radius: 13px;
  background: #f8f9fb;

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    padding: 10px 20px;
    font-size: 12px;
  }
`;

export const InfoSectionHighlighted = styled(InfoSection)`
  background-color: ${customColors.question};
`;

export const Organizations = styled(MUI.Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items:stretch;
  gap: 23px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;


export const RecipientUsers = styled(MUI.Stack)`
  flex-direction: row;
  justify-content: space-between;
  gap: 23px;
  flex-wrap: wrap;
`;

export const Label = styled("span")`
  color: ${customColors.info.label};
`;

export const Info = styled(MUI.Stack)`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  color: ${customColors.text};
  gap: 0.5rem;
`;

export const ListItem = styled(MUI.Box)`  
  color: ${customColors.text};
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  overflow-wrap: break-word;

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;
